// Removed Badge import as we're using custom styled divs
// Removed Lucide icons as we're using custom SVGs

interface ReferentResponse {
  referentName: string;
  value: boolean | null;
}

interface CriticalResponsesProps {
  responses: {
    wouldRecommend: ReferentResponse[];
    wouldRehire: ReferentResponse[];
    hasIncidents: boolean | null;
    confidenceLevel: number;
  };
}

export const CriticalResponses = ({ responses }: CriticalResponsesProps) => {
  return (
    <div className="w-full self-stretch rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-400/20 flex flex-col justify-start items-start overflow-hidden print-optimized" style={{ minHeight: '200px', backgroundColor: 'white' }}>
      {/* Header */}
      <div className="self-stretch p-4 bg-gray-50 border-b border-neutral-400/20 flex justify-start items-center gap-2.5">
        <div className="justify-start text-gray-800 text-xl font-medium font-['Bricolage_Grotesque']">Niveau de confiance</div>
      </div>

      {/* Content */}
      <div className="self-stretch px-6 py-6 flex flex-col justify-start items-start gap-6">
        {/* Les référents recommandent-ils le candidat ? */}
        <div className="self-stretch px-3 py-4 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-400/20 flex justify-start items-center gap-6">
          <div className="flex-1 flex justify-start items-start gap-2">
            <div className="size-9 p-2 bg-green-500/10 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 overflow-hidden">
              <div className="relative">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.8346 16.6667L8.96793 17.45C9.10011 17.4831 9.23584 17.4999 9.3721 17.5H12.7204C13.03 17.5 13.3335 17.4138 13.5968 17.251C13.8601 17.0882 14.0729 16.8553 14.2113 16.5783L17.1279 10.745C17.2549 10.4909 17.3148 10.2086 17.302 9.9248C17.2892 9.64104 17.2041 9.36525 17.0547 9.12364C16.9053 8.88202 16.6967 8.68259 16.4486 8.54427C16.2005 8.40595 15.9212 8.33334 15.6371 8.33333H11.6671H10.0004M5.8346 16.6667L5.83377 9.16667L8.66043 4.92667C8.99127 4.43083 9.1671 3.84917 9.1671 3.25333C9.1671 2.8375 9.5046 2.5 9.92127 2.5H10.0013C10.4433 2.5 10.8672 2.6756 11.1798 2.98816C11.4923 3.30072 11.6679 3.72464 11.6679 4.16667V8.33333M5.8346 16.6667H4.1671C3.72507 16.6667 3.30115 16.4911 2.98859 16.1785C2.67603 15.866 2.50043 15.442 2.50043 15V10C2.50043 9.55797 2.67603 9.13405 2.98859 8.82149C3.30115 8.50893 3.72507 8.33333 4.1671 8.33333H6.25043" stroke="#32CD32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-px">
              <div className="self-stretch justify-start text-gray-800 text-base font-medium font-['Bricolage_Grotesque']">Les référents recommandent-ils le candidat ?</div>
              <div className="self-stretch justify-start text-neutral-400 text-xs font-normal font-['Bricolage_Grotesque']">Basé sur les réponses collectées auprès des référents</div>
            </div>
          </div>
          <div className="flex justify-start items-center gap-6">
            {responses.wouldRecommend.map((response, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className="text-gray-800 text-xs font-medium">{response.referentName} :</div>
                {response.value === true && (
                  <div className="px-2 py-1 border border-green-500 rounded-md flex items-center">
                    <div className="text-green-500 text-xs font-medium">Oui</div>
                  </div>
                )}
                {response.value === false && (
                  <div className="px-2 py-1 border border-red-500 rounded-md flex items-center">
                    <div className="text-red-500 text-xs font-medium">Non</div>
                  </div>
                )}
                {response.value === null && (
                  <div className="px-2 py-1 border border-red-500 rounded-md flex items-center">
                    <div className="text-red-500 text-xs font-medium">NC</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Le réembaucheraient-ils ? */}
        <div className="self-stretch px-3 py-4 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-400/20 flex justify-between items-center">
          <div className="flex-1 flex justify-start items-start gap-2">
            <div className="size-8 p-2 bg-emerald-50 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 overflow-hidden">
              <div className="relative">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.1253 18.0583C15.7003 17.1166 18.3337 13.8666 18.3337 9.99996C18.3337 5.39996 14.6337 1.66663 10.0003 1.66663C4.44199 1.66663 1.66699 6.29996 1.66699 6.29996M1.66699 6.29996V2.49996M1.66699 6.29996H3.34199H5.36699" stroke="#32CD32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M1.66699 10C1.66699 14.6 5.40033 18.3333 10.0003 18.3333" stroke="#32CD32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3 3" />
                </svg>
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-px">
              <div className="justify-start text-gray-800 text-base font-medium font-['Bricolage_Grotesque']">Le réembaucheraient-ils ?</div>
              <div className="self-stretch justify-start text-neutral-400 text-xs font-normal font-['Bricolage_Grotesque']">Indicateur de satisfaction professionnelle</div>
            </div>
          </div>
          <div className="flex justify-start items-center gap-3">
            {responses.wouldRehire.map((response, index) => (
              <div key={index} className="flex justify-start items-center gap-3">
                <div className="justify-start text-gray-800 text-xs font-medium font-['Bricolage_Grotesque']">{response.referentName} :</div>
                {response.value === true && (
                  <div className="px-2 py-[5px] rounded-md outline outline-1 outline-offset-[-1px] outline-green-500 flex justify-center items-center gap-2.5">
                    <div className="justify-start text-green-500 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">Oui</div>
                  </div>
                )}
                {response.value === false && (
                  <div className="px-2 py-[5px] rounded-md outline outline-1 outline-offset-[-1px] outline-rose-500 flex justify-center items-center gap-2.5">
                    <div className="justify-start text-rose-500 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">Non</div>
                  </div>
                )}
                {response.value === null && (
                  <div className="px-2 py-[5px] rounded-md outline outline-1 outline-offset-[-1px] outline-rose-500 flex justify-center items-center gap-2.5">
                    <div className="justify-start text-rose-500 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">NC</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Rapports d'incidents */}
        <div className="self-stretch px-3 py-5 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-400/20 flex justify-start items-center gap-6">
          <div className="flex-1 flex justify-start items-start gap-2">
            <div className="size-8 p-2 bg-rose-500/10 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 overflow-hidden">
              <div className="relative">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 7.5V11.6667" stroke="#FF515D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.99986 17.8416H4.94986C2.0582 17.8416 0.849863 15.775 2.24986 13.25L4.84986 8.56665L7.29986 4.16665C8.7832 1.49165 11.2165 1.49165 12.6999 4.16665L15.1499 8.57498L17.7499 13.2583C19.1499 15.7833 17.9332 17.85 15.0499 17.85H9.99986V17.8416Z" stroke="#FF515D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.99512 14.1666H10.0026" stroke="#FF515D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-px">
              <div className="justify-start text-gray-800 text-base font-medium font-['Bricolage_Grotesque']">Rapports d'incidents</div>
              <div className="self-stretch justify-start text-neutral-400 text-xs font-normal font-['Bricolage_Grotesque']">Signalement d'événements problématiques</div>
            </div>
          </div>
          <div className={`px-2 py-[5px] rounded-md outline outline-1 outline-offset-[-1px] flex justify-center items-center gap-2.5 ${
            responses.hasIncidents === false ? 'outline-green-500' : 
            responses.hasIncidents === true ? 'outline-rose-500' : 
            'outline-neutral-400'
          }`}>
            {responses.hasIncidents === false && (
              <div className="justify-start text-green-500 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">Pas d'incident</div>
            )}
            {responses.hasIncidents === true && (
              <div className="justify-start text-rose-500 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">Incidents signalés</div>
            )}
            {responses.hasIncidents === null && (
              <div className="justify-start text-neutral-400 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">Non renseigné</div>
            )}
          </div>
        </div>

        {/* Niveau de confiance des réponses */}
        <div className="self-stretch px-3 py-5 bg-gray-50 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-400/20 flex justify-start items-start gap-6">
          <div className="flex-1 flex justify-start items-start gap-2">
            <div className="size-8 p-2 bg-teal-50 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 overflow-hidden">
              <div className="relative">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.66699 18.3334H18.3337" stroke="#40E0D0" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M8.125 3.33329V18.3333H11.875V3.33329C11.875 2.41663 11.5 1.66663 10.375 1.66663H9.625C8.5 1.66663 8.125 2.41663 8.125 3.33329Z" stroke="#40E0D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.5 8.33329V18.3333H5.83333V8.33329C5.83333 7.41663 5.5 6.66663 4.5 6.66663H3.83333C2.83333 6.66663 2.5 7.41663 2.5 8.33329Z" stroke="#40E0D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.167 12.5V18.3334H17.5003V12.5C17.5003 11.5834 17.167 10.8334 16.167 10.8334H15.5003C14.5003 10.8334 14.167 11.5834 14.167 12.5Z" stroke="#40E0D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-px">
              <div className="justify-start text-gray-800 text-base font-medium font-['Bricolage_Grotesque']">Niveau de confiance des réponses</div>
              <div className="self-stretch justify-start text-neutral-400 text-xs font-normal font-['Bricolage_Grotesque']">Basé sur la cohérence et la qualité des réponses</div>
            </div>
          </div>
          <div className="inline-flex flex-col justify-center items-center gap-1.5">
            <div className="justify-start text-teal-400 text-base font-medium font-['Bricolage_Grotesque']">{responses.confidenceLevel}%</div>
            <div className="px-1.5 py-1 bg-white rounded-full inline-flex justify-center items-center gap-2.5">
              <div className="justify-start text-neutral-400 text-[10px] font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">Confiance</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};